import { useEffect, useState } from "react";
//MUI
import { Skeleton, Stack, Typography } from "@mui/material";

// Context
import { SocialMediaReviewDetailedDialogProvider } from "@DataPages/context/customerRelations/SocialMediaReviewDetailedDialogContext.tsx";

// Helpers
import { or } from "@Common/helpers/sonar";

// Hooks
import useGetReviewDetailsInRange from "@DataPages/hooks/socialMediaReviews/useGetReviewDetailsInRange";

//Components
import SocialMediaReviewStoreTitle from "./SocialMediaReviewStoreTitle";
import SocialMediaReviewStoreTable from "./SocialMediaReviewStoreTable";
import ReviewsDatePicker from "../components/ReviewsDatePicker";

// Types
import { GridColDef } from "@mui/x-data-grid-pro";
import { IReviewDateRange } from "@DataPages/types/socialMediaReviews/utils";
import { TSelectionItem } from "../interfaces";

type SocialMediaReviewStoreProps = Readonly<{
	locationId: string;
	isLoading: boolean;
	selectedItem: TSelectionItem;
	columns: GridColDef[];
	rows: { [key: string]: string | number }[];
	isDataPresent: boolean;
}>;
export default function SocialMediaReviewStoreSection(props: Readonly<SocialMediaReviewStoreProps>) {
	const { locationId, selectedItem, isDataPresent } = props;
	const { commissionCycleId = "", payPeriodId, payPeriodEndDate = "", startDateCommissionCycle } = selectedItem ?? {};

	// States
	const [selectedDates, setSelectedDates] = useState<IReviewDateRange | null>(null);

	const { data, isLoading } = useGetReviewDetailsInRange("store", {
		commissionCycleId,
		dateRange: selectedDates,
	});

	useEffect(() => {
		return () => {
			setSelectedDates(null);
		};
	}, [commissionCycleId, payPeriodId, locationId]);

	return (
		<SocialMediaReviewDetailedDialogProvider>
			<Stack alignContent={"flex-start"}>
				<Stack spacing={2}>
					<SocialMediaReviewStoreTitle
						isLoading={props.isLoading}
						title={props.selectedItem?.title}
						isDataPresent={isDataPresent}
					/>

					<ReviewsDatePicker
						isDataPresent={isDataPresent}
						isDisabled={isLoading}
						isLoading={props.isLoading || !selectedItem}
						containerStyle={{ marginTop: "5px" }}
						minDate={startDateCommissionCycle}
						maxDate={payPeriodEndDate}
						selectedDates={selectedDates}
						// Callbacks
						setSelectedDates={setSelectedDates}
					/>
				</Stack>
				<Stack>
					{or(props.isLoading, Boolean(!props.selectedItem)) ? (
						<Skeleton variant="rectangular" height={25} width={200} className={"rounded-md mt-[20px]"} />
					) : (
						isDataPresent && <Typography className={"regular-montserrat-label fs-18 py-[16px]"}>Store</Typography>
					)}

					<SocialMediaReviewStoreTable
						// Table Data
						columns={data?.storeReviewsColumns ? data?.storeReviewsColumns : props.columns}
						rows={data?.dataStoreReviews?.length ? data?.dataStoreReviews : props.rows}
						selectedDates={selectedDates}
						isDataPresent={isDataPresent}
						isLoading={props.isLoading}
						selectedItem={selectedItem}
					/>
				</Stack>
			</Stack>
		</SocialMediaReviewDetailedDialogProvider>
	);
}
